import messagesFR from './fr.json'
import messagesEN from './en.json'
import { createI18n } from 'vue-i18n'

const I18N_MESSAGES = {
  fr: messagesFR,
  en: messagesEN
}

const SUPPORTED_LOCALES = Object.keys(I18N_MESSAGES)
const DEFAULT_LOCALE = 'fr'

const browserLocale = navigator.language.split('-')[0]

const locale = SUPPORTED_LOCALES.includes(browserLocale)
  ? browserLocale
  : DEFAULT_LOCALE

const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: SUPPORTED_LOCALES,
  warnHtmlMessage: false,
  messages: { ...I18N_MESSAGES },
  messageCompilerOptions: {
    linked: false
  }
})

export { i18n }
export { SUPPORTED_LOCALES, DEFAULT_LOCALE }
